import React from "react";
import { Spinner } from "react-bootstrap";


export const FallbackComponent = () => {
    return (
        <div style={{ width: "100%", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Spinner animation="border" style={{ width: "3rem", height: "3rem" }} />
        </div>
    );
};